const cardData = [
    {
        id:1,
        img: "./assets/chat.png",
        heading: "Chat",
        para: "Our agents are available 24/7",
    },
    {
        id:2,
        img: "./assets/Path2.png",
        heading: "Email",
        para: "contact@hogipay.com",
    },
    {
        id:3,
        img: "./assets/call.png",
        heading: "Call",
        para: "Our agents are available 24/7",
    },
  

]
export default cardData;